<template>
  <v-autocomplete
      :error-messages="error"
      variant="outlined"
      rounded="lg"
      bg-color="surface"
      :label="translation(translationList.house_year_of_construction, 'An construcție')"
      :items="years"
      name="year_of_construction"
      item-title="year"
      item-value="year"
      v-model="selectedYear"
      :rules="[v => !!v || translation(translationList.required, 'Acest câmp este obligatoriu')]"
  >
  </v-autocomplete>
</template>

<script lang="ts">
import {defineComponent, ref, watch, onMounted, toRefs} from 'vue';
import {useTranslationStore, translation} from '~/plugins/store/translations';
import type {TranslationList} from "~/types/Utils";

export default defineComponent({
  props: {
    modelValue: {
      type: Number as () => number | null,
      default: null,
      required: false
    },
  },
  emits: ['update:modelValue', 'validation-house-status'],
  setup(props, {emit}) {
    const {modelValue} = toRefs(props);
    const selectedYear = ref<number | null>(modelValue.value);
    const years = ref<{ year: number }[]>([]);
    const translationList = ref<TranslationList>({});
    const translationStore = useTranslationStore();
    const error = ref<string[]>([]);

    const getYears = () => {
      const currentYear = new Date().getFullYear();
      for (let year = currentYear; year >= currentYear - 100; year--) {
        years.value.push({year});
      }
    };

    onMounted(async () => {
      getYears();
      translationList.value = await translationStore.getTranslations('ro', 'dashboard');
      const isValid = !!selectedYear.value;
      emit('validation-house-status', {field: 'year_of_construction', isValid});

      // Listen for validate event
      window.addEventListener('validate-house', (data) => {
        if (data.detail && data.detail === 'year_of_construction') {
          if (!selectedYear.value) {
            error.value.push(translation(translationList.value.required, 'Acest câmp este obligatoriu'));
          } else {
            error.value = [];
            emit('validation-house-status', {field: 'year_of_construction', isValid: true});
          }
        }
      });
    });

    watch(selectedYear, (newValue) => {
      emit('update:modelValue', newValue);
    });

    watch(modelValue, (newValue) => {
      selectedYear.value = newValue;
      error.value = [];
      const isValid = !!newValue;
      emit('validation-house-status', {field: 'year_of_construction', isValid});
    });

    return {
      selectedYear,
      translationList,
      translation,
      years,
      error,
    };
  },
});
</script>